<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <!-- <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            [src]="user.avatar"> -->
        <mat-icon

            [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <!-- <span
            class="absolute right-0 bottom-0 w-2 h-2 rounded-full bg-green-500"

        ></span> -->
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item *ngIf="user.role == 'ADMIN_INSTITUTION' || user.role == 'RECEPCIONIST'">
        <span class="flex flex-col leading-none">
            <span>Email</span>
            <span class="mt-1.5 text-md font-medium">{{user.email}}</span>
        </span>
    </button>
    <button mat-menu-item *ngIf="user.role == 'CLIENT' || user.role == 'PROVIDER'" (click)="goToProfile()">
        <div class="flex flex-col">
        <span class="text-lg font-bold">{{user.name}} {{user.lastName}}</span>
            <span class="text-sm font-medium">{{user.email}}</span>


        <span class="flex py-4 items-center leading-none">
            <mat-icon [svgIcon]="'heroicons_outline:user'"></mat-icon>
            <span>Mi perfil</span>
        </span>
    </div>
    </button>
    <!-- <mat-divider class="my-2"></mat-divider> -->
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button> -->
    <!-- <button mat-menu-item (click)="openSettings()">
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings</span>

    </button> -->
    <!-- <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
        <span>Status</span>
    </button> -->

    <!-- *ngIf="user.role == 'ADMIN_INSTITUTION' && user.institution.coordinate == null" -->

    <mat-divider class="my-2"></mat-divider>
    <button
        *ngIf="user.role == 'ADMIN_INSTITUTION'"
        mat-menu-item
        (click)="changeCoordinates()">
        <mat-icon [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
        <span>Actualizar coordenadas</span>
    </button>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Cerrar sesión</span>
    </button>
</mat-menu>
<!--
<mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu> -->
